export const REGISTRATION_BY_DEVICE = {
  labels: ["Desktop", "Mobile", "Other"],
  series: [40, 30, 20],
};

export const EVENTS_DROPDOWN_FILTERS = ["Registrations", "Participations"];
